/**
 * Login Page
 */

import '../styles/main.css';
import { loadConfig } from '../config/config-loader';
import { initializeFirebase, signIn, onAuthChange, getAuthErrorMessage } from '../services/firebase-service';
import { showToast, showLoading, hideLoading } from '../utils/ui-helpers';

async function init() {
  try {
    // Load configuration
    const config = await loadConfig();

    // Initialize Firebase
    initializeFirebase(config.firebase);

    // Check if already logged in
    onAuthChange((user) => {
      if (user) {
        // Redirect to journal page
        window.location.href = 'journal.html';
      }
    });

    // Setup form submission
    const form = document.getElementById('auth-form') as HTMLFormElement;
    const emailInput = document.getElementById('auth-email') as HTMLInputElement;
    const passwordInput = document.getElementById('auth-password') as HTMLInputElement;
    const errorDiv = document.getElementById('auth-error') as HTMLDivElement;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = emailInput.value.trim();
      const password = passwordInput.value.trim();

      if (!email || !password) {
        showError('Vennligst fyll ut alle felt');
        return;
      }

      // Show loading
      errorDiv.classList.remove('show');
      form.style.display = 'none';
      showLoading('loading');

      try {
        await signIn(email, password);
        // Redirect will happen automatically via onAuthChange
      } catch (error: any) {
        // Show error
        hideLoading('loading');
        form.style.display = 'flex';
        showError(getAuthErrorMessage(error.code || 'unknown'));
      }
    });

    function showError(message: string) {
      errorDiv.textContent = message;
      errorDiv.classList.add('show');
    }
  } catch (error) {
    console.error('Initialization error:', error);
    showToast(error instanceof Error ? error.message : 'Feil ved oppstart av applikasjonen', true);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
